import { inject, Injectable } from '@angular/core';
import { NetworkHelper } from '../helpers';
import { SHARED_ENV } from '../tokens';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class RequestService {
  private readonly env = inject(SHARED_ENV);
  private readonly networkHelper = inject(NetworkHelper);

  private readonly hostUrl: string;

  constructor() {
    this.hostUrl = this.env.host;
  }

  getRequests(
    page: number,
    itemsPerPage: number,
    type: string,
    status: string,
    keyword?: string
  ): Observable<any> {
    const data: any = {
      page,
      itemsPerPage,
    };

    if (type && type !== 'any') {
      data['type'] = type;
    }

    if (status && status !== 'any') {
      data['status'] = status;
    }

    // Free-form: an ObjectId, an email fragment, or a CUB... brokerage account.
    if (keyword) {
      data['keyword'] = keyword;
    }

    return this.networkHelper.get(`${this.hostUrl}/request`, data);
  }

  getRequestById(id: string): Observable<any> {
    return this.networkHelper.get(`${this.hostUrl}/request/${id}`);
  }

  changeRequestStatus(id: string, status: string): Observable<any> {
    return this.networkHelper.patch(`${this.hostUrl}/request/${id}/status`, {
      status,
    });
  }
}
